import { contentAi } from '@mi-front/api-clients';
import { useIsContentAiEnabled } from './useIsContentAiEnabled';

export function useIsContentAiForStationEnabled(stationId: string) {
  const config = contentAi.useStationConfigGet(stationId);

  return useIsContentAiEnabled() && config.data?.enabled;
}
